import HttpHelpers from './helpers';

const AuthApiEndpoints = {
  login: (data) => {
    return HttpHelpers.authenticatedAxios
      .post('login', data)
      .then((response) => response.data);
  },

  signUp: (data) => {
    return HttpHelpers.authenticatedAxios
      .post('register', data)
      .then((response) => response.data);
  },

  logout: () => {
    return HttpHelpers.authenticatedAxios
      .post('logout')
      .then((response) => response.data);
  },

  confirmOtp: (otp, code) => {
    return HttpHelpers.authenticatedAxios
      .post(`otp/${otp}/confirm`, code)
      .then((response) => response.data);
  },

  resendOtp: (otp) => {
    return HttpHelpers.authenticatedAxios
      .post(`otp/${otp}/resend`)
      .then((response) => response.data);
  },

  forgetPassword: (data) => {
    return HttpHelpers.unAuthenticatedAxios
      .post('forget-password/phone', data)
      .then((response) => response.data);
  },

  verifyOtp: (data) => {
    return HttpHelpers.unAuthenticatedAxios
      .post('forget-password/phone/verify', data)
      .then((response) => response.data);
  },

  resetPassword: (data) => {
    return HttpHelpers.unAuthenticatedAxios
      .post('forget-password/phone/reset', data)
      .then((response) => response.data);
  },
};

export default AuthApiEndpoints;
